!function(window) {
/**
 *
 * @param {array} aParams
 * @param {array} aExcluded
 * @param {function} callback
 */
function getFilterResults(aParams, aExcluded, callback){
	$.get(
		`/util/ajaxresponse.php?lng=${pageLng}&${createParamsString(aParams, [])}`,
		function(data) {
			
			if(data == ''){
				return;
			}
			
			if(callback){
				var jqueryHtml = $(data);
				callback(jqueryHtml);
			}
			
			var params = `${createParamsString(aParams, aExcluded)}`;
			if (history && params.length){
				history.pushState(null, null, '?' + params);
			}else{
				// clear params from link
				window.history.replaceState(null, '', window.location.pathname);
			}
			
			
			setSimplePagination();
		}
	).fail(
		function(data){
			$('.data-content').html("Error occurred!");
		}
	)
	
	function createParamsString(aParams, aExcluded){
		return Object.keys(aParams)
				.filter((key) => aExcluded.indexOf(key) === -1)
				.reduce((joined, current) => {
					if( current == 'map' ){ // exception
						return joined + `&${current}`;
					}
					if( aParams[current] === null || aParams[current] === ''){
						return joined;
					}
					return joined + `&${current}=${aParams[current]}`
				}, '').substring(1);
	}
}

function onPaginationNewsClick(pageNumber, e){
	e.preventDefault();
	$('.data-content').addClass('opacity-loading').trigger('classChangeLoading');
	
	const strId = $('#body-content').attr('data-strid');
	const areaId = $('#area').val();
	
	var params = {func: 'get-page-news', str: strId};
	if( pageNumber > 1 ){
		params['page'] = pageNumber;
	}
	if( areaId ){
		params['area'] = areaId;
	}
	
	getFilterResults(params, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
		$('.data-content').removeClass('opacity-loading');
	});
}

function onPaginationEventsClick(pageNumber, e, showAll = false){
	e.preventDefault();
	$('.data-content').addClass('opacity-loading').trigger('classChangeLoading');
	$('.filter-event').removeClass('active');
	
	var start = $('input#datepickerStart').val().replace(/\s/g, '');
	var end = $('input#datepickerEnd').val().replace(/\s/g, '');
	
	const strId = $('#body-content').attr('data-strid');
	const areaId = $('#area').val();
	const rubricId = $('#rubric').val();
	
	var params = {func: 'get-page-events', str: strId};
	if( pageNumber > 1 ){
		params['page'] = pageNumber;
	}
	if(!showAll) {
		if(start != ''){
			params['dateFrom'] = start;
		}
		if(end != ''){
			params['dateTo'] = end;
		}
	} else {
		params['showAll'] = 1;
	}
	if( areaId ){
		params['area'] = areaId;
	}
	if( rubricId ){
		params['rubric'] = rubricId;
	}
	
	getFilterResults(params, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
		$('.data-content').removeClass('opacity-loading');
	});
}

function onPaginationTradEventsClick(pageNumber, e){
	e.preventDefault();
	$('.data-content').addClass('opacity-loading');
	
	const strId = $('#body-content').attr('data-strid');
	const areaId = $('#area').val();
	
	var params = {func: 'get-trad-events', str: strId};
	if( pageNumber > 1 ){
		params['page'] = pageNumber;
	}
	if( areaId ){
		params['area'] = areaId;
	}
	
	getFilterResults(params, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
		$('.data-content').removeClass('opacity-loading');
	});
}

function onPaginationPoiClick(pageNumber, e, category = null) {
	e.preventDefault();
	$('.whole-content').addClass('opacity-loading').trigger('classChangeLoading');
	
	const func = $('#filterMenu').attr('data-func');
	const strId = $('#body-content').attr('data-strid');
	const areaId = $('#area').val();
	
	var params = {func: func, str: strId };
	if( pageNumber > 1 ){
		params['page'] = pageNumber;
	}
	if( areaId ){
		params['area'] = areaId;
	}
	category = category != null ? category : $('.filterButton.active').attr('id');
	if(category){
		params['category'] = category;
	}
	
	getFilterResults(params, ['func', 'str'], function( jqueryHtml ){
		
		$('.whole-content').empty();
		$('.whole-content').append(jqueryHtml);
		$('.whole-content').removeClass('opacity-loading');
		//$('#mapLink').attr('href', '?map'+( params['area'] ? '&area='+params['area'] : '')+( params['category'] ? '&category='+params['category'] : ''));
	});
}

function callNewPageData(pageNumber, event, functionName){
	if(functionName == 'get-news'){
		onPaginationNewsClick(pageNumber, event);
	}else if(functionName == 'get-events'){
		onPaginationEventsClick(pageNumber, event);
	}else if(functionName == 'get-trad-events'){
		onPaginationTradEventsClick(pageNumber, event);
	
	}else if(functionName == 'get-providers'){
		onPaginationPoiClick(pageNumber, event);
	}else if(functionName == 'get-sights'){
		onPaginationPoiClick(pageNumber, event);
	}
}

function setSimplePagination(){
	if($('.pagination').length){
		//var currentTheme = $('html').attr('data-theme');
		$('.pagination').pagination({
			displayedPages: 5,
			edges: 1,
			ellipsePageSet: false,
			items: $('.pagination').attr('data-total'),
			itemsOnPage: $('.pagination').attr('data-limit'),
			currentPage : $('.pagination').attr('data-current'),
			nextText: '<svg xmlns="http://www.w3.org/2000/svg" width="12.828" height="22.829"><path d="m1.414 1.415 10 10-10 10" fill="none" stroke="#222" stroke-linecap="round" stroke-width="2"/></svg>',
			prevText: '<svg xmlns="http://www.w3.org/2000/svg" width="12.828" height="22.829"> <path d="m11.586 1.415-10 10 10 10" fill="none" stroke="#222" stroke-linecap="round" stroke-width="2"/></svg>',
			onPageClick: function(pageNumber, event) {
				var functionName = $('.pagination').attr('data-func');
				callNewPageData(pageNumber, event, functionName);
			}
		});
	}
}
setSimplePagination();

function formatDate(date){
	var aDate = date.split(".");
	return aDate[2]+'-'+aDate[1]+'-'+aDate[0];
}

function setDependentDate(){
	const defaultMinDate = new Date();
	const $pickerStart = $( ".datepicker-here.start" );
	$pickerStart.datepicker({
		//minDate: defaultMinDate,
		//dateFormat: 'd. m. yyyy',
		todayButton: true,
		clearButton: true,
		autoClose: true,
		onSelect: function( selectedDate ) {
			let minDateSelected =  new Date(formatDate(selectedDate));
			if(selectedDate == ''){
				//minDateSelected = defaultMinDate;
				minDateSelected = '';
			}
			$(".datepicker-here.end").datepicker({ minDate: minDateSelected });
			//$(".datepicker-here.end").trigger('focus');
		}
	});
	if($pickerStart.data('inputed') != ''){
		console.log( formatDate($pickerStart.data('inputed')) );
		$pickerStart.data('datepicker').selectDate(new Date(formatDate($pickerStart.data('inputed'))));
	}
	
	const $pickerEnd = $( ".datepicker-here.end" );
	$pickerEnd.datepicker({
		//minDate: defaultMinDate,
		//dateFormat: 'd. m. yyyy',
		todayButton: true,
		clearButton: true,
		autoClose: true,
		onSelect: function( selectedDate ) {
			let maxDateSelected =  new Date(formatDate(selectedDate));
			if(selectedDate == ''){
				maxDateSelected = '';
			}
			$( ".datepicker-here.start" ).datepicker({ maxDate: maxDateSelected });
			//$(".datepicker-here.end").trigger('blur');
		}
	});
	if($pickerEnd.data('inputed') != ''){
		$pickerEnd.data('datepicker').selectDate(new Date(formatDate($pickerEnd.data('inputed'))));
	}
}

if($(".datepicker-here.end").length > 0){
	setDependentDate();
}

function appendParameterToLink(param){
	const pageDomain = window.location.protocol+'//'+window.location.hostname;
	$('.topButtons a').each(function( index ) {
		var link = $(this).attr('href');
		const url = new URL(link, pageDomain);
		url.searchParams.append('category', param);
		let newUrlLink = url.href.replace('map=', 'map');
		$(this).attr('href', newUrlLink);
	});
}

$('.filterAreasNews select').on('change', function(e){
	e.preventDefault();
	callNewPageData(1, e, $('#filterMenu').attr('data-func'));
});


const buttonSelector = '.filterButton';
$(document).on('click', buttonSelector, function(e){
	e.preventDefault();
	
	var category = null;
	if($(this).hasClass('active')){
		$(buttonSelector).removeClass('active');
	}else{
		$(buttonSelector).removeClass('active');
		$(this).addClass('active');
		category = $(this).attr('id')
	}
	
	onPaginationPoiClick(1, e, category);
});

$(document).on('change', '.filterAreas select', function(e){
	e.preventDefault();
	$('.filterButton.active').removeClass('active'); // fix because category filter is dynamic
	onPaginationPoiClick(1, e, null);
});

$('.btn-events').on('click', function(e){
	onPaginationEventsClick(1, e);
});
$('.btn-events-all').on('click', function(e){
	onPaginationEventsClick(1, e,true);
});

$('.search-trigger, #searchButton').on('click', function(e){
	e.preventDefault();
	e.stopPropagation();
	$('#searchWrapper').show();
	$('#searchHeader').focus();
});

$('#startSearch').on('click', function(e){
	e.preventDefault();
	e.stopPropagation();
	$('#search-mini-form').submit();
});

$('#closeSearch').on('click', function(e){
	e.preventDefault();
	e.stopPropagation();
	$('#searchWrapper').hide();
});


$('.link').on('click', function(e){
	if(e.target.nodeName !== 'A'){
		const link = $( this ).data( "link" );
		window.location.href = link;
	}
});

$('body').on('classChangeLoading', function() {
	let offsetTop = 0;
	
	const clientHeight = document.documentElement.clientHeight;
	const fromTop  = window.pageYOffset || document.documentElement.scrollTop;
	
	const heightLoadingHalf = 150 / 2;
	const opacityLoadingDiv = document.querySelector(".opacity-loading").getBoundingClientRect();
	const divX = opacityLoadingDiv.x;
	const divTop = opacityLoadingDiv.top;
	const divHeight = opacityLoadingDiv.height;
	
	if( divTop >= 0 && divTop+divHeight <= clientHeight ){ // cel div na ekranu
		offsetTop = divHeight/2 - heightLoadingHalf;
		
	}
	else if( divX + divHeight < fromTop + clientHeight ){ // spodnji rob na ekranu
		const onScreenHeight = divHeight - divTop;
		offsetTop = onScreenHeight / 2 - heightLoadingHalf;
	}
	else if( divTop >= 0 ){ // zgornji rob na ekranu
		offsetTop = divTop / 2 + heightLoadingHalf;
	}
	else{ // vmes div
		offsetTop = divTop + clientHeight/2 - heightLoadingHalf;
	}
	
	$("body").get(0).style.setProperty("--loadingTop", offsetTop+"px");
});

window.getFilterResults = getFilterResults;
window.onPaginationNewsClick = onPaginationNewsClick;
window.onPaginationEventsClick = onPaginationEventsClick;
window.onPaginationTradEventsClick = onPaginationTradEventsClick;
window.onPaginationPoiClick = onPaginationPoiClick;
window.callNewPageData = callNewPageData;
window.setSimplePagination = setSimplePagination;
window.formatDate = formatDate;
window.setDependentDate = setDependentDate;
window.appendParameterToLink = appendParameterToLink;
window.buttonSelector = buttonSelector;
}.call(window, window);